module.exports = __webpack_public_path__ + "static/img/szy-details.afabc77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/szy-details.png
// module id = liID
// module chunks = 0